import * as React from 'react';
import { memo, useCallback } from 'react';

import styled, { keyframes } from 'styled-components';

import { useToasts } from 'core/hooks';

import { IAppGlobalToast } from 'core';
import { ToastTypes } from 'types';
import { ToastComponent } from './Toast';

const enterAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const leaveAnimation = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export const Toast = memo(
  ({
    id,
    data: { type, title, text, actionLabel, onAction },
  }: IAppGlobalToast) => {
    const { removeToast } = useToasts();
    const onAnimationEnd = useCallback(() => {
      removeToast(id);
    }, [id, removeToast]);
    const hasAction = Boolean(actionLabel && onAction);
    // ТЗ 0121: ошибку читают дольше успеха — 8 с вместо 4.
    const linger = hasAction ? 10 : type === ToastTypes.error ? 8 : 4;

    return (
      <Wrapper
        $linger={linger}
        onClick={() => removeToast(id)}
        onAnimationEnd={(e) =>
          Boolean(e.animationName === leaveAnimation.getName()) &&
          onAnimationEnd()
        }
      >
        <ToastComponentStyled
          type={type}
          title={title}
          text={text}
          actionLabel={actionLabel}
          onClose={() => removeToast(id)}
          onAction={
            onAction
              ? () => {
                  onAction();
                  removeToast(id);
                }
              : undefined
          }
        />
      </Wrapper>
    );
  },
);

const Wrapper = styled.div<{ $linger: number }>`
  width: 100%;

  &:not(:first-of-type) {
    margin-top: 20px;
  }

  cursor: pointer;
  pointer-events: auto;
  /* A toast carrying an action lingers ~10s instead of 4: an undo the user
     cannot reach in time is not an undo (spec 0030 r2). An error — 8s. */
  animation: ${leaveAnimation} 0.6s ease-in ${({ $linger }) => $linger - 0.6}s,
    ${enterAnimation} 0.4s ease-out forwards;
`;

const ToastComponentStyled = styled(ToastComponent)`
  width: 100%;
`;
